// extracted by mini-css-extract-plugin
export default {"mainHeader":"GlobalServices_mainHeader__prCG9","subHeader":"GlobalServices_subHeader__bCVUv"};